export default __webpack_public_path__ + "static/media/log_sign_image.0546de16.png";